// extracted by mini-css-extract-plugin
var _1 = "styles-module__container____0xgH";
var _2 = "styles-module__routeColor___P0Fnw";
var _3 = "styles-module__stat___h2RIn";
var _4 = "styles-module__statInfo___xvZAc";
var _5 = "styles-module__statTitle___x7cYv";
var _6 = "styles-module__total___o3TQT";
export { _1 as "container", _2 as "routeColor", _3 as "stat", _4 as "statInfo", _5 as "statTitle", _6 as "total" }
